import { Typography } from 'antd';
import classes from './EmptyChart.module.scss';
import { EmptyChartIcon } from '@/components';

type EmptyChartPropsType = {
  title: string;
};

export const EmptyChart = ({ title }: EmptyChartPropsType) => {
  return (
    <div className={classes.emptyChartWrapper}>
      <div className={classes.emptyChartPanel}>
        <Typography.Title level={3} className="mb-0">
          {title}
        </Typography.Title>
      </div>
      <div className={classes.emptyChartContent}>
        <EmptyChartIcon />
        <Typography.Text type="secondary">No data</Typography.Text>
      </div>
    </div>
  );
};
